import { gql } from '@apollo/client'

export const GET_MODULE = gql`
  query getCourseModules(
    $id: ID!
    $moduleId: ID
    $offset: Int!
    $limit: Int!
    $submodulesOffset: Int!
    $submodulesLimit: Int!
    $courseContentsOffset: Int!
    $courseContentsLimit: Int!
  ) {
    course(id: $id) {
      id
      courseModules(
        id: $moduleId
        main: true
        pagination: { offset: $offset, limit: $limit }
      ) {
        nodes {
          id
          name
          available
          coverUrl
          courseModules(
            pagination: { offset: $submodulesOffset, limit: $submodulesLimit }
          ) {
            id
            name
            available
            courseContentsCount
            parentCourseModule {
              id
            }
            courseContents(
              pagination: {
                offset: $courseContentsOffset
                limit: $courseContentsLimit
              }
            ) {
              nodes {
                id
                available
                lesson {
                  id
                  title
                  releaseAt
                  courseContentId
                  releaseAfter
                  courseClassReleaseOffset
                  lockAt
                  lockAfter
                  createdAt
                  activity {
                    id
                    examQuestionsCount
                  }
                  media {
                    id
                    type
                    duration
                    hostKey
                    host
                    fileExt
                    text
                    organizationUuid
                    originUrl
                    providerKey
                  }
                  coverImage {
                    cdnFileUrl
                  }
                  containsExtraMedias
                }
              }
            }
          }
          courseContentsCount
          courseContents(
            pagination: {
              offset: $courseContentsOffset
              limit: $courseContentsLimit
            }
          ) {
            nodes {
              id
              available
              lesson {
                id
                courseContentId
                title
                releaseAt
                releaseAfter
                courseClassReleaseOffset
                lockAt
                lockAfter
                createdAt
                activity {
                  id
                  examQuestionsCount
                }
                media {
                  id
                  type
                  duration
                  hostKey
                  host
                  fileExt
                  text
                  organizationUuid
                  originUrl
                  providerKey
                }
                coverImage {
                  cdnFileUrl
                }
              }
            }
          }
        }
      }
    }
  }
`
